import YaCounter from "../../analytics/ym";
import {
	findID,
	find,
	isEmptyObj,
	mergeDeepObject,
	isObject,
	isJsonString,
	output_roubles,
	findAll,
	output_products_count,
	addClass,
	removeClass,
} from "../../../../../../../modules/vegas/js/util";
import VGCatalog from "../catalog/catalog";

class VGCatalogCart extends VGCatalog {
	constructor() {
		super();
	}

	/**
	 * Добавление в корзину
	 * @param product
	 * @param callback
	 */
	add(product, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null),
			title = product.dataset.title || 'Товар';

		axios.post('/cart/add_product', {
			id: id,
		}).then((response) => {
			_this.total(response.data);

			new YaCounter().goal('add-to-cart');

			if (typeof callback === "function") {
				return callback(response.data);
			}
		});
	}

	/**
	 * Удаление из корзины
	 * @param product
	 * @param callback
	 */
	remove(product, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null),
			title = product.dataset.title || 'Товар';

		if (id) {
			axios.post('/cart/del_product', {
				id: id
			}).then((response) => {
				_this.total(response.data);
				_this.toggleForm(response.data.disable);

				if (typeof callback === "function") {
					return callback(response.data);
				}
			});
		}
	}

	/**
	 * Изменение количества
	 * @param product
	 * @param cnt
	 * @param appendParams
	 * @param callback
	 */
	change(product, cnt, appendParams = {}, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null);
		let params = mergeDeepObject({
			id: id,
			cnt: cnt
		}, appendParams)

		params = this.formData(params, true);

		axios.post('/cart/change_product', params)
			.then((response) => {
				if (typeof callback === 'function') {
					callback(response.data);
				}

				_this.total(response.data);
				_this.toggleForm(response.data.disable);
			});
	}

	/**
	 * Обновляем всё
	 */
	update() {
		const _this = this;
		let params = _this.formData({}, true);

		axios.get('/cart/get_totals', {
			params: params
		}).then((response) => {
			_this.total(response.data);
			_this.toggleForm(response.data.disable);
		});
	}

	/**
	 * Сколько всего накидали в корзину, выводим цифры
	 * @param data
	 * @returns {boolean}
	 */
	total(data) {
		if (typeof data === 'string') {
			if (isJsonString(data)) {
				data = JSON.parse(data);
			} else {
				return false
			}
		}

		if (isEmptyObj(data)) return false;

		if ('products_count' in data && typeof data.products_count !== 'undefined') {
			findAll('[data-cart][data-counter=products]').forEach((elem) => {
				elem.setAttribute('data-cnt', data.products_count);
			});
		}

		if ('sums' in data && !isEmptyObj(data.sums)) {
			if ('sum_products' in data.sums && typeof data.sums.sum_products !== 'undefined') {
				findAll('[data-cart][data-counter="products-sum"]').forEach((elem) => {
					elem.setAttribute('data-sum', data.sums.sum_products);

					if (elem.hasAttribute('with-value')) {
						elem.innerHTML = output_roubles(data.sums.sum_products);
					}
				});
			}
		}

		[...findAll('.delivery-area .delivery-section .msg.error')].forEach((el) => {
			el.classList.add('d-none');
			el.innerHTML = '';
		});
		if ('delivery_info' in data && data.delivery_info) {
			for (let id in data.delivery_info) {
				let info = data.delivery_info[id];
				let deliveryElem = find(`.delivery-area .delivery-section[data-id="${id}"]`);

				if (typeof info.error_msg !== 'undefined' && deliveryElem) {
					let msgElem = deliveryElem.querySelector('.msg.error');
					if (msgElem) {
						msgElem.insertAdjacentHTML('beforeend', info.error_msg.map(el => {
							return `<div>${el}</div>`;
						}).join(''));
						msgElem.classList.remove('d-none');
					}
				}
			}
		}

		totalCartForm(data);
		totalCartProducts(data);

		function totalCartForm(data) {
			let form = findID('form-cart'),
				sums = isObject(data) && ('sums' in data) && isObject(data.sums) ? data.sums : {};

			if (form) {
				// products sum
				let sProducts = form.querySelector('[data-sum="products"]');
				if (sProducts) {
					let sumValue = sProducts.querySelector('[data-sum-value]');
					if (sumValue) {
						let sumProducts = ('sum_products' in sums) ? sums.sum_products : 0
						sumValue.innerHTML = output_roubles(sumProducts)
					}

					let sCntProducts = sProducts.querySelector('[data-title]');
					if (sCntProducts) {
						let cntProducts = ('products_count' in data) ? data.products_count : 0
						sCntProducts.innerHTML = output_products_count(cntProducts)
					}
				}

				// cart sum
				let sCart = form.querySelector('[data-sum="total"]');
				if (sCart) {
					let cartSumValue = sCart.querySelector('[data-sum-value]');
					if (cartSumValue) {
						let sum = ('sum' in sums) ? sums.sum : 0;
						cartSumValue.innerHTML = output_roubles(sum);
					}
				}

				// promocode
				let sPromocode = form.querySelector('[data-sum=promocode]');
				if (sPromocode && 'sum_promocode' in sums) {
					if (sums.sum_promocode) {
						sPromocode.querySelector('[data-sum-value]').innerHTML = output_roubles(sums.sum_promocode)
						removeClass(sPromocode, 'd-none');
					} else {
						addClass(sPromocode, 'd-none');
					}
				}

				let promoPercent = form.querySelector('.cart-promocode .percent');
				if (promoPercent && ('percent_promocode' in sums)) {
					promoPercent.innerHTML = sums.percent_promocode;
				}

				// user discount
				let sUserDiscount = form.querySelector('[data-sum=user_discount]');
				if (sUserDiscount) {
					if ('sum_user_discount' in sums && sums.sum_user_discount > 0) {
						let promoSumValue = sUserDiscount.querySelector('[data-sum-value]');
						if (promoSumValue) {
							promoSumValue.innerHTML = output_roubles(sums.sum_user_discount)
						}

						removeClass(sUserDiscount, 'd-none');
					} else {
						addClass(sUserDiscount, 'd-none');
					}
				}

				// delivery sum
				let sDelivery = form.querySelector('[data-sum="delivery"]');
				if (sDelivery) {
					if ('sum_delivery' in sums) {
						let deliverySumValue = sDelivery.querySelector('[data-sum-value]');

						if (deliverySumValue) {
							if (sums.sum_delivery === -1) {
								deliverySumValue.innerHTML = 'недоступно';
								addClass(deliverySumValue, 'error');
							} else {
								removeClass(deliverySumValue, 'error');
								deliverySumValue.innerHTML = isNaN(sums.sum_delivery) ? sums.sum_delivery : (
									sums.sum_delivery > 0 ? output_roubles(sums.sum_delivery) : 'бесплатно'
								)
							}
						}

						removeClass(sDelivery, 'd-none');
					} else {
						addClass(sDelivery, 'd-none')
					}
				}
			}
		}

		function totalCartProducts(data) {
			let cartProducts = find('.catalog-cart--products');
			if (cartProducts && ('products_totals' in data) && data.products_totals) {
				for (let i in data.products_totals) {
					let p = data.products_totals[i];

					let cartPivot = cartProducts.querySelector(`[data-product-cart-item][data-pivot_id="${p.pivot_id}"]`);
					if (cartPivot) {
						let priceTotal = cartPivot.querySelector('.price-total');
						if (priceTotal) {
							priceTotal.innerHTML = output_roubles(p.price_total)
						}
					}
				}
			}
		}
	}

	/**
	 *
	 * @param params
	 * @param toArray
	 */
	formData(params = {}, toArray = false) {
		let form = findID('form-cart');
		let formData = null;

		formData = form ? new FormData(form) : new FormData();
		for (let name in params) {
			formData.append(name, params[name]);
		}

		if (formData && toArray) {
			let res = {};

			let components = Array.from(formData);
			for (let item of components) {
				res[item[0]] = item[1];
			}

			return res;
		}

		return formData;
	}

	toggleForm(disable) {
		let form = findID('form-cart');

		if (form) {
			let btn = form.querySelector('button[type=submit]');

			if (btn) {
				btn.disabled = disable;
			}
		}
	}
}

export default VGCatalogCart
